const utils = (storeUtils = window.flex) => {

    const { getStore } = storeUtils;

    const DEFAULT_MODULE_NAME = 'flex';
    const MODULE_SELECTOR = '#app';

    function appLoaded() {
        let store = getStore();

        return store.appContext && store.localText;
    }

    function getModuleName() {
        return $(MODULE_SELECTOR).attr('data-module-name') || DEFAULT_MODULE_NAME;
    }

    return {
        version: '1.0',
        debug: true,
        apiBaseUrl: '',
        contentBaseUrl: '',
        rmsAppCode: 'RMS-PORTAL',

        alert: message => { alert(message); },
        appLoaded,
        getModuleName
    };
};

module.exports = utils;